<template>
	<div>
		<h5 class="heading">{{ finishGroup.name }}</h5>
		<div class="finishes">
			<Finish v-for="(finish, index) in finishGroup.finishes" :key="index" :finish="finish" :finishSelectedProp="finishSelectedProp" @finishSelected="onFinishSelected" />
		</div>
	</div>
</template>

<script>
	import Finish from './Finish.vue';

	export default {
			props: ['finishGroup', 'finishSelectedProp'],
			data() {
					return {
							finishSelected: null,
					};
			},
			methods: {
				onFinishSelected: function(finish) {
					this.finishSelected = finish;
					this.$emit('finishSelected', this.finishSelected);
				}
			},
			components: {
				Finish,
			},
	};
</script>

<style scoped>
	.heading {
		font-size: 10px;
		text-transform: uppercase;
		line-height: 1.2;
		margin: 10px 0;
	}

	.finishes {
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		gap: 1rem 2rem;
	}
</style>